import React, { useState } from "react";

import dayjs from "dayjs";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { apiResolveStr } from "../../../../apiBindings";
import { toReadableDate } from "../../../../utils/DateHelpers";
import useStore from "../../../pages/GasStations/GasStation/store";
import Icon from "../../icons/Icon";
import LinkComponent from "../../LinkComponent";
import Card from "../Card";

const Subline = styled.h5`
    ${({ theme }) => theme.paddings.containerOuterInner.left}
    ${({ theme }) => theme.paddings.containerOuterInner.right}

    margin-bottom: 10px;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.blue.toString()};
    display: flex;
    column-gap: 20px;
    font-variant-numeric: tabular-nums;
`;

const InnerContainer = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    ${({ theme }) => css`
        ${theme.breakpoints.from.small.css`
          ${theme.paddings.containerOuterInner.left}
          ${theme.paddings.containerOuterInner.right}
      `}
    `}
`;

const LinkWrapper = styled.div`
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}
`;

const MenuCard = ({ data }) => {
    const theme = useTheme();
    const [expanded, setExpanded] = useState(
        dayjs(data.from).isSameOrBefore(dayjs()) &&
            dayjs(data.to).isSameOrAfter(dayjs())
    );

    const { gasStation } = useStore();

    const toggleExpand = (event) => {
        event.preventDefault();
        setExpanded(!expanded);
    };

    if (data?.meals < 1) {
        return null;
    }

    return (
        <div>
            <Subline onClick={toggleExpand}>
                <div>
                    Wochenangebot: {toReadableDate(data.from)} -{" "}
                    {toReadableDate(data.to)}
                </div>
                <Icon
                    iconName="chevron"
                    color={theme.colors.blue.toString()}
                    size="16px"
                    css={css`
                        ${expanded && "transform: rotate(90deg)"}
                    `}
                />
            </Subline>
            {expanded && (
                <InnerContainer>
                    {data.meals.map((item, index) => {
                        return (
                            <Card
                                key={index}
                                left={item.day}
                                middle={item.parts}
                                right={item.price}
                            />
                        );
                    })}
                    <LinkWrapper>
                        <LinkComponent
                            link={{
                                text: "Menüplan Herunterladen",
                                href: apiResolveStr(
                                    `/gas-stations/${gasStation.s_id}/menus/${data.id}/pdf`
                                ),
                            }}
                            fontSize="1rem"
                            button
                            css={css`
                                margin: 0 auto;
                            `}
                        />
                    </LinkWrapper>
                </InnerContainer>
            )}
        </div>
    );
};

export default MenuCard;
